import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitScheduledModel } from '@apps-common/types/portal/unit-scheduled'

export const QUERY_KEY_GET_UNIT_SCHEDULES = (unitId?: string) => ['getUnitScheduleds', unitId].filter(Boolean)

const getUnitScheduleds = async (unitId: string): Promise<IUnitScheduledModel[]> =>
  axios.get(`/unitscheduled/getscheduleds?unitId=${unitId}`).then((res) => res.data?.data)

type QueryFnType = typeof getUnitScheduleds

type Props = {
  config?: QueryConfig<QueryFnType>
  unitId: string
}

export const useGetUnitScheduleds = ({ config, unitId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_KEY_GET_UNIT_SCHEDULES(unitId),
    queryFn: () => getUnitScheduleds(unitId)
  })
